module.exports = __webpack_public_path__ + "static/img/advance02.4855151b.png";